import { render } from "./edit.vue?vue&type=template&id=d88537b4&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=d88537b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d88537b4"

export default script